import { render, staticRenderFns } from "./PageTemplateButton.vue?vue&type=template&id=4ccc3c3c&scoped=true&"
import script from "./PageTemplateButton.vue?vue&type=script&lang=js&"
export * from "./PageTemplateButton.vue?vue&type=script&lang=js&"
import style0 from "./PageTemplateButton.vue?vue&type=style&index=0&id=4ccc3c3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ccc3c3c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VItem } from 'vuetify/lib/components/VItemGroup';
installComponents(component, {VItem})
